module.exports = __webpack_public_path__ + "static/img/jp.3e72015c.svg";